<template>
	<div class="address-info" >
		<h3>收货地址</h3>
		<div>
			<div class="mb10 item-address">
				<label>收货人：</label>
				<p>{{ orderAddress.receiverName }}</p>
			</div>
			<div class="mb10 item-address">
				<label>地址：</label>
				<p>{{ orderAddress.provinceName }} {{ orderAddress.cityName }} {{ orderAddress.districtName }} {{ orderAddress.detailAddress }}</p>
			</div>
			<div class="mb10 item-address">
				<label>手机号码：</label>
				<p>{{ orderAddress.receiverPhone }}</p>
			</div>
		</div>
        <el-link style="margin-left: 0" type="primary" @click="handleModify" v-if="orderBasic.tradeStatus == 0 ||orderBasic.tradeStatus == 1 ||orderBasic.tradeStatus == 8">修改</el-link>

        <!-- 修改收货地址 -->
        <DialogAddress ref="DialogAddressRef" :checkedAddressId="checkedAddressId" @confirmAddress="confirmAddress"></DialogAddress>
	</div>
 </template>

<script>
import DialogAddress from './DialogAddress.vue';
import { getConsumerOrderAddress } from '@/api/order/order';
export default {
	props: {
		orderAddress: {
			type: Object,
			required: true
		},
        orderBasic: {
            type: Object,   
            required: true
        }
	},
    components: {
        DialogAddress   
    },
	data() {
		return {
            checkedAddressId: null
        };
	},
    watch: {
        orderAddress: {
            handler(newVal) {
                // console.log('newVal',newVal)
                this.checkedAddressId = newVal.id;
            },
            immediate: true
        }
    },
    methods: {
        handleModify() {        
            this.$refs.DialogAddressRef.dialogVisible = true;
        },

        confirmAddress(addressId) {
            if (!addressId) {
                this.$message.warning('请选择收货地址');
                return;
            }
            getConsumerOrderAddress({
                orderNo: this.orderBasic.tradeNo,
                addressId: addressId
            }).then(res => {
                this.$message.success('收货地址修改成功');
                this.$refs.DialogAddressRef.dialogVisible = false;
                this.$emit('addressUpdated');
            }).catch(err => {
                this.$message.error('收货地址修改失败');
            });
        }
    }
};
</script>

<style scoped lang="less">
.address-info {
	h3 {
		margin: 0;
		font-weight: 400;
		font-size: 18px;
		color: #333333;
        margin-bottom: 20px;
	}

    .item-address {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        label {
            width: 80px;
            color: #333333;
            font-size: 13px;
        }
        p {
            margin: 0;
            color: #333333;
            font-size: 13px;
        }
    }
}
</style>
